<script setup lang="ts">

interface Props {
  type?: string
  position?: string
}

withDefaults(defineProps<Props>(), {
  type: 'primary',
  position: 'center',
})
const emit = defineEmits<{
  (e: 'close'): void
}>()

const closeAlert = () => {
  emit('close')
}

</script>

<template>
  <div
    class="alert d-flex"
    role="alert"
    :class="['alert-' + type, 'align-items-' + position]"
  >
    <div
      v-if="$slots['icon']"
      class="me-2 flex-shrink-0"
    >
      <slot name="icon" />
    </div>
    <slot name="text" />
    <button
      type="button"
      class="btn-close ms-auto"
      aria-label="Закрыть"
      @click.prevent="closeAlert"
    />
  </div>
</template>

